<template>
  <div class="app-container">
    <router-view v-slot="{ Component, route }">
      <component
        :is="Component"
        :key="route.path"
      />
    </router-view>
  </div>
</template>
<script lang="ts">
import { App } from 'vue';
import { Lazyload } from 'vant';
import CustomPlugin from './plugins/custom';

export default {
  // 应用的生命周期钩子
  appCreated(app: App) {
    // 使用了 vant 中的 lazyload，其与 vue-lazyload 配置和特性保持一致
    // 详见：https://youzan.github.io/vant/v3/#/zh-CN/lazyload
    app.use(Lazyload, {
      preload: 1.5,
      attempt: 2,
      observer: true,
      observerOptions: {
        rootMargin: '150%',
        threshold: 0,
      },
    });
    app.use(CustomPlugin);
  },
};
</script>
<style lang="scss">
@import './styles/index';
.app-container{
  width: 100vw;
  height: 100%;
}
</style>
